import styled from "styled-components";

export const FeedbackMeetingCyclesContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
`;